import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Spacer, Text } from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import { AppSelectors, UserManagementSelectors, UserSelectors } from 'app/shared/selectors';
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';
import TableMFH from 'app/shared/components/TableMFH';
import UserManagementActions from 'app/shared/actions/UserManagementActions';
import columnConfigs from './columnConfigs';

// Stylesheets
import './style.scss';

const propTypes = {
};

const UsersPage = ({
    isScreenMobile,
    dispatch,
    company,
    companyUsers,
    activeTab,
    user,
    users,
}) => {
    const handleResendInvite = (invitedUser) => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.RESEND_COMPANY_INVITE_MODAL,
            targetEmail: invitedUser.email,
            userName: invitedUser.userName,
            header: 'Resend invite',
            onClose: () => dispatch(ModalActions.hideModal()),
            onSubmit: () => {
                dispatch(UserManagementActions.resendInviteEmail(invitedUser))
                    .then(() => dispatch(ModalActions.hideModal()));
            },
        }));
    };

    const columnConfig = columnConfigs.getConfigs(isScreenMobile, dispatch,
        handleResendInvite, company, user.userToken, activeTab, companyUsers);
    const isLoading = company.isLoading || companyUsers.isLoading;
    const renderEmptyTableMessage = () => {
        if (users.length !== 0 || companyUsers.isLoading) {
            return null;
        }
        return (
            <Spacer marginY="xl">
                <Center>No Users Found</Center>
            </Spacer>
        );
    };

    const renderContent = () => {
        if (companyUsers.error || company.error) {
            return (
                <Text as="div" fontColor="red600">
                    Cannot retrieve user management information. Please try again later.
                </Text>
            );
        }

        return (
            <React.Fragment>
                <TableMFH
                    columnConfig={columnConfig}
                    data={users}
                    idKey="email"
                />
                {renderEmptyTableMessage()}
            </React.Fragment>
        );
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div className="UsersPage">
                <HeadWrapper title="Users" />
                {isLoading ? <SpinnerContainer /> : renderContent()}
            </div>
        </AuthCheckWrapper>
    );
};

const mapStateToProps = state => ({
    isScreenMobile: AppSelectors.makeIsScreenMobile(state),
    company: UserManagementSelectors.makeCompany(state),
    companyUsers: UserManagementSelectors.makeCompanyUsers(state),
    activeTab: UserManagementSelectors.makeActiveTab(state),
    user: UserSelectors.makeUser(state),
    users: UserManagementSelectors.makeUserList(state),
});

UsersPage.propTypes = propTypes;

export { UsersPage };
export default withRouter(connect(mapStateToProps)(UsersPage));
